import {
  createMuiTheme,
  createStyles,
  makeStyles,
} from '@material-ui/core';
import { FONT_FAMILY } from '../../../constants';

export const useStyles = makeStyles(() =>
  createStyles({
    selectBox: {
      paddingLeft: '15px',
      borderRadius: '5px',
    },
    firstDiv: {
      backgroundColor: '#D3D3D3',
      height: '60px',
      width: '50%',
      marginTop: '10px',
      display: 'flex',
      justifyContent: 'space-around',
      paddingTop: '10px',
    },
    firstDivMobile: {
      backgroundColor: '#D3D3D3',
      height: '60px',
      marginTop: '10px',
      display: 'flex',
      justifyContent: 'space-around',
      paddingTop: '10px',
    },
    textDiv: {
      textAlign: 'center',
      fontFamily: FONT_FAMILY,
      fontWeight: 'bold',
      fontSize: '14px',
    },
    select: {
      maxWidth: '130px',
      minWidth: '128px',
      maxHeight: '250px',
    },
    selectMobile: {
      maxWidth: '108px',
      minWidth: '108px',
    },
  })
);

export const materialTheme = createMuiTheme({
  overrides: {
    MuiInput: {
      underline: {
        '&:after': {
          borderBottom: 'none',
        },
        '&:before': {
          borderBottom: 'none',
        },
      },
    },
    MuiSelect: {
      select: {
        backgroundColor: 'white',
        '&:focus': {
          backgroundColor: 'white',
          borderRadius: '5px',
        },
      },
    },
    MuiInputBase: {
      root: {
        borderRadius: 5,
        fontSize: '14px',
        width: '100%',
      },
    },

    MuiMenu: {
      paper: {
        maxHeight: '250px',
        '@media (max-width: 768px)': {
          top: '140px !important',
        },
        top: '190px !important',
      },
    },

    MuiMenuItem: {
      root: {
        fontSize: '14px !important',
        lineHeight: 1.5,
      },
    },
  },
});



// WEBPACK FOOTER //
// ./src/Pages/HomePage/FilterSection/index.styles.js